<template>
    <div id="customer-manage">
        <div class="flex items-center justify-between">
            <vs-button color="primary" icon-pack="feather" icon="icon-plus" @click="popupAddCustomer = true">
                Thêm mới khách hàng
            </vs-button>
            <h3 class="text-primary text-center flex-1 text-center"
                style="transform: translateX(-50%);left: 50%;position: absolute;">DANH SÁCH KHÁCH HÀNG CƠ HỘI</h3>
        </div>
        <div class="vx-card px-6 py-4 mt-2">
            <div class="mb-4 flex items-center gap-4">
                <label class="vs-input--label" style="min-width: 10%;">Chọn cột hiển thị</label>
                <v-select v-model="selectedColumns" :options="columnOptions" multiple :close-on-select="false"
                    label="label" :reduce="option => option.value" class="flex-[4] w-4/5">
                </v-select>
                <vs-button color="primary" icon-pack="feather" icon="icon-check" @click="updateVisibleColumns"
                    class="flex-grow" style="max-width: 20% ; min-width: 13%">
                    Xác nhận
                </vs-button>
            </div>
            <div class="">
                <vs-table :data="customerData" noDataText="Không có dữ liệu"
                    style="height: calc(var(--vh, 1vh) * 100 - 300px); min-height: 200px">
                    <template slot="thead">
                        <vs-th>
                            STT
                        </vs-th>
                        <vs-th style="min-width: 200px;max-width: 250px;">
                            <div class="w-full">
                                <label>Khách hàng tương tác</label>
                                <vs-input class="w-full" v-model="fullName" @keyup.enter="filterManage"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px ; max-width: 250px;">
                            <div class="w-full">
                                <label>SĐT</label>
                                <vs-input class="w-full" v-model="phoneNumber" @keyup.enter="filterManage"></vs-input>
                            </div>
                        </vs-th>
                        <!--                        <vs-th style="width: 170px">-->
                        <!--                            <div class="w-full">-->
                        <!--                                <label class="vs-input&#45;&#45;label">Tài khoản tương tác</label>-->
                        <!--                                <v-select class="w-full" v-model="selectedSeeder" :options="seederOptions" :clearable="false"-->
                        <!--                                          :reduce="options => options.value" @input="filterManage"></v-select>-->
                        <!--                            </div>-->
                        <!--                        </vs-th>-->
                        <vs-th style="min-width: 280px;">
                            <div class="w-full">
                                <label class="vs-input--label">Kênh MXH</label>
                                <v-select class="w-full group-fb" v-model="groupChatId" :options="groupFB"
                                    :clearable="false" name="branch" :reduce="option => option.value"
                                    @input="filterManage">
                                    <template #option="{ label, stt }">
                                        <span style="margin: 0">{{ stt ? stt + '. ' : null }}{{ label }}</span>
                                    </template>
                                    <template #selected-option="{ label, stt }">
                                        <div class="flex items-center gap-2">
                                            <span>{{ stt ? stt + '. ' : null }}{{ label }}</span>
                                        </div>
                                    </template>
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width:200px" v-if="isVisible('sourceType')">
                            <div class="w-full">
                                <label class="vs-input--label">Nguồn khai thác</label>
                                <v-select class="" v-model="selectedSource" :clearable="false" :options="sourceOption"
                                    :reduce="options => options.value" @input="filterManage"></v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('departmentName')">
                            <div class="w-full">
                                <label class="vs-input--label">Nguồn khách</label>
                                <v-select class="w-full" v-model="selectedDepartmentValue" :clearable="false"
                                    :options="dataConfig" :reduce="option => option.value"
                                    @input="getGroupByDepartment($event)">
                                    <template #option="{ label, organizationBranchName }">
                                        <div style="margin: 0"><span class="text-lg">{{ label }}</span></div>
                                        <em>{{ organizationBranchName }}</em>
                                    </template>
                                    <template #selected-option="{ label, organizationBranchName }">
                                        <div class="flex items-center gap-2">
                                            <span>{{ label }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('interactMethod')">
                            <div class="w-full">
                                <label class="vs-input--label">Hình thức tương tác</label>
                                <v-select class="w-full" v-model="selectedInteracMethod" :clearable="false"
                                    :options="interacMethodOptions" :reduce="options => options.value"
                                    @input="filterManage"></v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('seen')">
                            <div class="w-full">
                                <label class="vs-input--label">Trạng thái</label>
                                <v-select class="w-full" v-model="selectedSeen" :clearable="false"
                                    :options="seenOptions" :reduce="options => options.value"
                                    @input="filterManage"></v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('lastMessage')">
                            Lịch sử tin nhắn
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('detail')">
                            Zalo
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('employeeName')">
                            <div class="w-full">
                                <label class="vs-input--label">Nhân viên</label>
                                <vs-input class="w-full" v-model="employeeName" @keyup.enter="filterManage" />
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px" v-if="isVisible('upgradedDateCvt')">
                            <div>
                                <label class="vs-input--label">Ngày lên cơ hội</label>
                                <div class="flex relative" style="width: 200px">
                                    <flat-pickr :config="configDatePicker" v-model="dateRangeGrade.startDate"
                                        class="vs-inputx vs-input--input normal" @input="filterManage" />
                                    <flat-pickr :config="configDatePicker" v-model="dateRangeGrade.endDate"
                                        class="vs-inputx vs-input--input normal" @input="filterManage" />
                                </div>
                            </div>
                        </vs-th>
                        <!-- <vs-th style="min-width: 200px"  v-if="isVisible('employeeNamegt')">
                            <div class="w-full">
                                <label class="vs-input--label">Nhân viên giới thiệu</label>
                                <vs-input class="w-full" v-model="employeeName" @keyup.enter="filterManage" />
                            </div>
                        </vs-th> -->
                        <vs-th style="width: 250px" v-if="isVisible('createdDateCvt')">
                            <div>
                                <label class="vs-input--label">Ngày lưu</label>
                                <div class="flex relative" style="width: 200px">
                                    <flat-pickr :config="configDatePicker" v-model="dateRange.startDate"
                                        class="vs-inputx vs-input--input normal" @input="filterManage" />
                                    <flat-pickr :config="configDatePicker" v-model="dateRange.endDate"
                                        class="vs-inputx vs-input--input normal" @input="filterManage" />
                                </div>
                            </div>
                        </vs-th>
                        <vs-th style="width: 150px">
                            Hành động
                        </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{ tr.stt }}
                            </vs-td>

                            <vs-td class="text-primary">
                                <div @click="detailsRecord(tr)">{{ tr.fullName }}</div>
                                <div class="text-sm text-grey" v-if="tr.isSeeder">{{
                                    tr.isSeeder ? 'Seeder' : null
                                    }}
                                </div>
                                <p v-if="countFullName[indextr]">{{ countFullName[indextr] }}</p>
                            </vs-td>
                            <vs-td>
                                <div class="flex gap-2">
                                    <span>{{ tr.phoneNumberCvt }}</span>
                                    <vx-tooltip class="position-icon" text="Gọi" position="top">
                                        <feather-icon icon="PhoneCallIcon" class="text-primary" svgClasses="h-5 w-5"
                                            @click="callCustomer(tr)" />
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                            <!--                            <vs-td>-->
                            <!--                                <vs-chip class="ag-grid-cell-chip-customer flex items-center" v-if="tr.isSeeder"-->
                            <!--                                         color="primary">-->
                            <!--                                    Seeding-->
                            <!--                                </vs-chip>-->
                            <!--                            </vs-td>-->
                            <vs-td class="over-text">
                                {{ tr.groupName }}
                                <p v-if="ratioMXH[indextr]">
                                    <span style="color: blue;">{{ ratioMXH[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ ratioMXH[indextr].split(' ')[2] }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />
                            </vs-td>
                            <vs-td v-if="isVisible('sourceType')">
                                {{ checkSource(tr.sourceType) }}
                                <p v-if="ratioSourceType[indextr]">
                                    <span style="color: blue;">{{ ratioSourceType[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ ratioSourceType[indextr].split(' ')[2] }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />
                            </vs-td>
                            <vs-td v-if="isVisible('departmentName')">
                                {{ tr.departmentName }}
                                <p v-if="ratioSource[indextr]">
                                    <span style="color: blue;">{{ ratioSource[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ ratioSource[indextr].split(' ')[2] }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />

                            </vs-td>
                            <!--                            <vs-td>-->
                            <!--                                {{ tr.insertedAtCvt }}-->
                            <!--                            </vs-td>-->
                            <vs-td v-if="isVisible('interactMethod')">
                                <vs-chip class="ag-grid-cell-chip-customer"
                                    :color="chipColorInteracMethod(tr.interactMethod)">
                                    {{ checkInteracMethod(tr.interactMethod) }}
                                </vs-chip>
                                <p v-if="radioCountInteractMethod[indextr]">
                                    <span style="color: blue;">{{ radioCountInteractMethod[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ radioCountInteractMethod[indextr].split(' ')[2] }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />

                            </vs-td>
                            <vs-td v-if="isVisible('seen')">
                                <vs-chip class="ag-grid-cell-chip-customer" :color="chipColorSeen(tr.seen)">
                                    {{ checkSeen(tr.seen) }}
                                </vs-chip>
                            </vs-td>
                            <!--                            <vs-td>-->
                            <!--                                {{ tr.lastMessageDateCvt }}-->
                            <!--                            </vs-td>-->
                            <vs-td class="cursor-pointer hover:font-semibold hover:underline over-text"
                                v-if="isVisible('lastMessage')">
                                <span @click="showMessage(tr)">{{ tr.lastMessage }}</span>
                            </vs-td>
                            <vs-td v-if="isVisible('detail')">
                                <div>
                                    <span @click="getDataZaloHub(tr)" style="cursor: pointer;">Xem chi tiết</span>
                                    <feather-icon class="ml-2 mt-2" icon="EditIcon"
                                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                                        @click="getDataZaloHub(tr)" />
                                </div>
                            </vs-td>
                            <vs-td v-if="isVisible('employeeName')">
                                {{ tr.employeeName }}
                            </vs-td>
                            <vs-td v-if="isVisible('upgradedDateCvt')">
                                {{ tr.upgradedDateCvt }}
                            </vs-td>
                            <!-- <vs-td v-if="isVisible('employeeNamegt')">
                                {{ tr.employeeName }}
                            </vs-td> -->
                            <vs-td v-if="isVisible('createdDateCvt')">
                                {{ tr.createdDateCvt }}
                            </vs-td>
                            <vs-td>
                                <vx-tooltip text="Đặt lịch">
                                    <feather-icon class="ml-2 mt-2" icon="CalendarIcon"
                                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                                        @click="openPopup(tr)" />
                                </vx-tooltip>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <vs-popup class="holamundo" title="Đặt lịch" :active.sync="popupBooking" id="popup_beauty_booking"
                v-if="popupBooking">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <label class="vs-input--label required">Chi nhánh</label>
                        <v-select v-model="selectedBranchCreate" :options="branchCreateOptions" :clearable="false">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                    <div class="vx-col w-full mt-6">
                        <vs-radio v-model="packageType" vs-value="1" class="mr-4" @change="changeSelectType">Nhóm dịch
                            vụ
                        </vs-radio>
                        <vs-radio v-model="packageType" vs-value="2" @change="changeSelectType">Gói dịch vụ
                        </vs-radio>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="packageType == 1">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <label class="vs-input--label required">Nhóm dịch vụ</label>
                                <v-select v-model="selectBeautyService" :options="beautyServiceData" :clearable="false"
                                    v-validate="''" name="nameServiceType">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label required">Dịch vụ</label>
                                <v-select v-model="selectBeautyServicePackage" :options="beautyServicePackageOptions"
                                    :clearable="false" v-validate="''" name="nameServicePacks">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label">Bác sĩ</label>
                                <v-select class="w-full" v-model="selectedDoctorCreate" :options="doctorCreateOptions"
                                    :clearable="false" v-validate="''" name="doctor">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('doctor') }}</span>
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label">Ghi chú</label>
                                <vs-input class="w-full" v-model="note"></vs-input>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="packageType == 2">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <label class="vs-input--label required">Gói dịch vụ</label>
                                <v-select v-model="selectedComboService" :options="beautyComboService"
                                    :clearable="false" v-validate="''" name="comboService">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                        <label class="vs-input--label">Ngày</label>
                        <div class="w-full">
                            <datepicker :highlighted="highlighted" class="w-full" :language="vi" :format="'dd/MM/yyyy'"
                                v-model="selectDate" data-vv-validate-on="input" ref="datepickBooking"
                                v-validate="'required'" name="time">
                            </datepicker>
                            <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                        <label class="vs-input--label">Giờ</label>
                        <div class="w-full">
                            <flat-pickr :config="configTimePickerBooking" v-model="selectTime"
                                class="w-full vs-inputx vs-input--input normal" name="time"></flat-pickr>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <div class="flex flex-wrap float-right">
                            <vs-button color="primary" class="mt-6 text-center mr-2" @click="saveBooking"
                                :disabled="!validateForm">Tạo mới
                            </vs-button>
                            <vs-button color="warning" type="border" class="mt-6 text-center"
                                @click="popupBooking = false">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>


            <div class="vx-row mt-4" v-if="customerData.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        customerData.length - currentPageManage * pageSizeManage > 0 ? currentPageManage *
                                            pageSizeManage
                                            : customerData.length
                                    }} /
                                    {{ totalElementsManage }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSizeManage(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSizeManage(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSizeManage(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSizeManage(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <span style="margin-left: 20px; margin-top: 8px;">Số lượng khách hàng đã đặt lịch: </span>
                        <span style="margin-left: 20px; margin-top: 8px;">{{ ratio }}%</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPagesManage" v-model="currentPageManage" @change="loadPageManage" />
                </div>
            </div>
        </div>

        <vs-popup class="holamundo" title="Lịch sử tin nhắn" :active.sync="popupHistoryMessage">
            <VuePerfectScrollbar class="border border-solid d-theme-border-grey-light" :settings="settings"
                ref="chatLogPS" :key="$vs.rtl">
                <div class="chat__log" ref="chatLog">
                    <MessagePancake :messageData="messageData"></MessagePancake>
                </div>
            </VuePerfectScrollbar>
        </vs-popup>
        <vs-popup class="holamundo fullscreen" title="Zalo Hub" :active.sync="popupShowZaloHub" v-if="popupShowZaloHub">
            <div>
                <ZaloHubPancake :zaloHubData="zaloHubData"></ZaloHubPancake>
            </div>
        </vs-popup>
        <vs-popup class="holamundo" title="Thông tin khách hàng" fullscreen :active.sync="popupAddCustomer"
            v-if="popupAddCustomer">
            <CustomerInformation :isProp="true" />
        </vs-popup>
        <vs-popup class="holamundo customer-info" title="Khách hàng" :active.sync="popupInfo" id="customer_info_popup"
            v-if="popupInfo">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Thông tin khách hàng">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <CustomerInformation :loyaltyCustomerId="dataRow.id"></CustomerInformation>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử nhắn tin">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <HistorySMS :loyaltyCustomerId="dataRow.id"></HistorySMS>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử cuộc gọi">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <CallHistory :phone="dataRow.phoneNumber"></CallHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử đặt lịch">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <BookingHistory :loyaltyCustomerId="dataRow.id"></BookingHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử ra vào">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <InOutHistory :loyaltyCustomerId="dataRow.id"></InOutHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử tư vấn">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <ConsultingStep :loyaltyCustomerId="dataRow.id"></ConsultingStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử thanh toán">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <FeeCollectionStep :loyaltyCustomerId="dataRow.id"></FeeCollectionStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử điều trị">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <SubclinicalStep :loyaltyCustomerId="dataRow.id"></SubclinicalStep>
                    </VuePerfectScrollbar>
                </vs-tab>
            </vs-tabs>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from "moment";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { isAPI } from "../../../../store/permission";
import { constAPI } from "../../../../store/constant";
import Datepicker from 'vuejs-datepicker';
import { en, vi } from "vuejs-datepicker/dist/locale";
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import MessagePancake from "@/views/user-pages/crm-module/customer/message-pancake/MessagePancake";
import ZaloHubPancake from "@/views/user-pages/crm-module/customer/message-pancake/ZaloHubPancake";
import CustomerInformation from "./CustomerInformation";
import HistorySMS from "./cell-renderer/history-sms/HistorySMS";
import ConsultingStep from "./cell-renderer/medical-step/ConsultingStep";
import FeeCollectionStep from "./cell-renderer/medical-step/FeeCollectionStep";
import SubclinicalStep from "./cell-renderer/medical-step/SubclinicalStep";
import InOutHistory from "./cell-renderer/medical-step/InOutHistory";
import BookingHistory from "./cell-renderer/medical-step/BookingHistory";
import CallHistory from "./cell-renderer/medical-step/CallHistory";

export default {
    components: {
        vSelect,
        VuePerfectScrollbar,
        flatPickr,
        Datepicker,
        DateRangePicker,
        MessagePancake,
        ZaloHubPancake,
        CustomerInformation,
        HistorySMS,
        ConsultingStep,
        FeeCollectionStep,
        SubclinicalStep,
        InOutHistory,
        BookingHistory,
        CallHistory
    },
    data() {
        return {
            customerData: [],
            pageNumberManage: 0,
            pageSizeManage: 30,
            totalPagesManage: 0,
            currentPageManage: 1,
            totalElementsManage: 0,
            en: en,
            vi: vi,
            genderOptions: [
                { value: null, label: 'Tất cả' },
                { value: 0, label: this.$t('genderOption.unknown') },
                { value: 1, label: this.$t('genderOption.male') },
                { value: 2, label: this.$t('genderOption.female') }
            ],
            fullName: null,
            phoneNumber: null,
            groupFB: [{ label: 'Tất cả', value: 'null' }],
            groupChatId: 'null',
            dateRange: {
                startDate: new Date(new Date().setHours(0, 0, 0, 0)),
                endDate: new Date(new Date().setHours(23, 59, 59, 999))
            },
            dateRangeGrade: {
                startDate: null,
                endDate: null
            },
            departmentOptions: [],
            selectedDepartmentValue: null,
            dataConfig: [{ value: null, label: 'Tất cả' },],
            messageData: [],
            popupHistoryMessage: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.70,
            },
            dataGroupFB: [],
            interacMethodOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Tin nhắn' },
                { value: 2, label: 'Bình luận' },
            ],
            selectedInteracMethod: null,
            seenOptions: [
                { value: null, label: 'Tất cả' },
                { value: 0, label: 'Chưa đọc' },
                { value: 1, label: 'Đã đọc' },
            ],
            selectedSeen: null,
            employeeName: null,
            selectedSeeder: null,
            seederOptions: [
                { value: null, label: 'Tất cả' },
                { value: 0, label: 'Khách hàng' },
                { value: 1, label: 'NV tương tác' },
            ],
            sourceOption: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'App' },
                { value: 3, label: 'Nhân sự' },
                { value: 16, label: 'Zalo' },
                { value: 17, label: 'Tiktok' },
                { value: 14, label: 'Facebook' },
                { value: 4, label: 'Khác' },
            ],
            sourceTypeOptionsManage: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Phòng kinh doanh 1' },
                { value: 2, label: 'Phòng kinh doanh 2' },
                { value: 3, label: 'Nhân viên' },
                { value: 4, label: 'Phòng kinh doanh 3' },
                { value: 5, label: 'Phòng kinh doanh 4' },
                { value: 6, label: 'Nguồn khác' },
                { value: 7, label: 'Nguồn App' },
            ],
            configDatePicker: {
                dateFormat: 'Z',
                locale: Vietnamese,
                altFormat: 'd/m/Y',
                altInput: true,
                allowInput: true,
            },
            popupShowZaloHub: false,
            popupBooking: false,
            branchOptions: [],
            branchCreateOptions: [],
            packageType: 1,
            beautyServiceData: [],
            beautyServicePackageOptions: [],
            doctorCreateOptions: [],
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            selectDate: new Date(),
            selectTime: new Date(),
            configTimePickerBooking: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            loyaltyCustomerId: null,
            beautyComboService: [],
            popupAddCustomer: false,
            dataRow: null,
            activeTab: 0,
            popupInfo: false,
            selectedSource: null,
            sourceType: null,
            note: '',
            selectedColumns: ['sourceType', 'departmentName', 'interactMethod', 'seen', 'lastMessage', 'detail', 'employeeName', 'upgradedDateCvt', 'createdDateCvt'],
            visibleColumns: {
                sourceType: true,
                departmentName: true,
                interactMethod: true,
                seen: true,
                lastMessage: true,
                detail: true,
                employeeName: true,
                upgradedDateCvt: true,
                createdDateCvt: true,
                employeeNamegt: true,
            },
            columnOptions: [
                { label: 'Nguồn khai thác', value: 'sourceType' },
                { label: 'Nguồn khách', value: 'departmentName' },
                { label: 'Hình thức tương tác', value: 'interactMethod' },
                { label: 'Trạng thái', value: 'seen' },
                { label: 'Lịch sử tin nhắn ', value: 'lastMessage' },
                { label: 'Zalo', value: 'detail' },
                { label: 'Nhân viên ', value: 'employeeName' },
                { label: 'Ngày lên cơ hội', value: 'upgradedDateCvt' },
                { label: 'Ngày lưu', value: 'createdDateCvt' },
            ],
            countFullName: [],
            ratio: null,
            ratioMXH: [],
            ratioSourceType: [],
            ratioSource: [],
            radioCountInteractMethod: [],
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.branchOptions.unshift({ value: null, label: 'Tất cả' })
        this.branchCreateOptions = this.branchOptions.filter(x => x.value);
        await this.getAllDepartment();
        await this.getDepartmentConfig();
        await this.getGroupFB();
        await this.getAllRadio()
        this.findCustomerData();
        this.updateVisibleColumns();

    },
    watch: {
        '$store.state.isUpdateVipCustomer'(val) {
            if (val) {
                this.filterManage();
                this.$store.commit('UPDATE_VIP_CUSTOMER', false);
            }
        }
    },
    computed: {
        chipColor() {
            return value => {
                if (value === 1) {
                    return "success";
                } else {
                    return 'warning'
                }
            }
        },
        checkStatus() {
            return value => {
                if (value === 1) {
                    return 'Chính thức'
                } else {
                    return 'Tiềm năng'
                }
            }
        },
        validateForm() {
            return !this.errors.any();
        },
        checkSource() {
            return value => {
                if (value === 1) {
                    return 'APP'
                } else if (value === 3) {
                    return 'Nhân sự'
                }
                else if (value === 4) {
                    return 'Khác'
                }
                else if (value === 14) {
                    return 'Facebook'
                }
                else if (value === 16) {
                    return 'Zalo'
                }
                else if (value === 17) {
                    return 'Tiktok'
                }
                else {
                    return ''
                }
            }
        },

        checkCustomerSource() {
            return value => {
                if (value === 1) {
                    return 'Facebook'
                } else {
                    return ''
                }
            }
        },

        checkInteracMethod() {
            return value => {
                if (value === 1) {
                    return 'Tin nhắn'
                } else if (value === 2) {
                    return 'Bình luận'
                } else return 'Khác'
            }
        },

        chipColorInteracMethod() {
            return value => {
                if (value === 1) {
                    return "success";
                } else if (value === 2) {
                    return 'warning'
                } else return 'primary';
            }
        },

        chipColorSeen() {
            return value => {
                if (value === 0) {
                    return "danger";
                } else if (value === 1) {
                    return 'success'
                } else return 'primary';
            }
        },

        checkSeen() {
            return value => {
                if (value === 0) {
                    return "Chưa đọc";
                } else if (value === 1) {
                    return 'Đã đọc'
                } else return 'Khác'
            }
        },
        selectedBranchCreate: {
            get() {
                let obj = this.branchCreateOptions.find(x => x.value === this.selectedBranchCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.selectedBranchCreateValue = obj ? obj.value : null;
                this.selectBeautyServiceValue = null;
                this.selectedComboServiceValue = null;
                if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
                if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
                this.doctorCreateOptions = [];
                await this.$validator.reset();
            }
        },
        selectBeautyService: {
            get() {
                let obj = this.beautyServiceData.find(x => x.value === this.selectBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServiceValue = obj ? obj.value : null;
                this.getBeautyServicePack();
            }
        },
        selectBeautyServicePackage: {
            get() {
                let obj = this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServicePackageValue = obj ? obj.value : null;
                this.selectedDepartmentCreateValue = obj ? obj.departmentId : null;
                this.getDoctor();
            }
        },
        selectedDoctorCreate: {
            get() {
                let obj = this.doctorCreateOptions.find(x => x.value === this.selectedDoctorCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorCreateValue = obj ? obj.value : null;
            }
        },
        selectedComboService: {
            get() {
                let obj = this.beautyComboService.find(x => x.value === this.selectedComboServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedComboServiceValue = obj ? obj.value : null;
            }
        },
    },
    methods: {

        isVisible(columnKey) {
            return this.visibleColumns[columnKey];
        },
        updateVisibleColumns() {
            this.visibleColumns = this.columnOptions.reduce((acc, col) => {
                acc[col.value] = this.selectedColumns.includes(col.value);
                return acc;
            }, {});
        },
        async detailsRecord(data) {
            this.dataRow = data;
            this.activeTab = 0;
            this.popupInfo = true;
        },

        openPopup(tr) {
            this.loyaltyCustomerId = tr.id
            this.popupBooking = true
        },
        async changeSelectType() {
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;
            this.selectBeautyService = null

            if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
            if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
        },

        getAllRadio() {
            const body = {
                phoneNumber: this.phoneNumber,
                fullName: this.fullName,
                groupChatId: JSON.parse(this.groupChatId),
                type: 3,
                pageNumber: this.pageNumberManage,
                pageSize: this.pageSizeManage,
                createDateFrom: this.dateRange.startDate,
                createDateTo: this.dateRange.endDate,
                modifiedDate: this.dateRangeGrade.startDate,
                toModifiedDate: this.dateRangeGrade.endDate,
                departmentId: JSON.parse(this.selectedDepartmentValue),
                employeeName: this.employeeName,
                seen: this.selectedSeen,
                interactMethod: this.selectedInteracMethod,
                isSeeder: this.selectedSeeder,
                sourceType: this.selectedSource
            }
            this.$vs.loading();
            this.$crm.post(`/loyalty/potential-customer/radio_proportion_customer`, body).then(response => {
                this.ratioSourceType = []
                this.radioCountInteractMethod = []
                this.ratioMXH = []
                this.ratioSource = []
                this.countFullName = []
                if (response.data.countLoyaltyPotentialCustomer.length > 1) {
                    response.data.countLoyaltyPotentialCustomer.forEach(el => {
                        this.ratioSourceType.push(el.countSourceType);
                        this.radioCountInteractMethod.push(el.countInteractMethod);
                        this.ratioMXH.push(el.countGroupChatId);
                        this.ratioSource.push(el.countDepartmentId);
                        this.countFullName.push(el.countFullName);
                    });
                }
                this.ratio = response.data.radioBooking

            })
        },

        async saveBooking(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (!this.selectedBranchCreateValue) {
                return this.$vs.notify({
                    text: 'Chi nhánh là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if (this.packageType == 1 && !this.selectBeautyServiceValue
            ) {
                return this.$vs.notify({
                    text: 'Nhóm dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }

            if (this.packageType == 1 && !this.selectBeautyServicePackageValue) {
                return this.$vs.notify({
                    text: 'Dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }

            if (this.packageType == 2 && !this.selectedComboServiceValue) {
                return this.$vs.notify({
                    text: 'Gói dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',

                    color: 'warning'
                });
            }
            if ((new Date(this.selectDate) <= new Date()) && (new Date(this.selectTime).getTime() < new Date().getTime())) {
                return this.$vs.notify({
                    text: 'Thời gian đặt lịch phải lớn hơn thời gian hiện tại!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if (!/^\d{2}:\d{2}$/.test(this.selectTime)) {
                const date = new Date(this.selectTime);
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                return this.selectTime = `${hours}:${minutes}`;
            }

            let payload = {
                organizationBranchId: this.selectedBranchCreateValue,
                loyaltyCustomerId: this.loyaltyCustomerId,
                isDoctorCreate: true,
                packageType: this.packageType,
                presentStatus: 0,
                note: this.note,
                beautyBookingDetails: [
                    {
                        beautyServicePackageId: this.selectBeautyServicePackageValue,
                        bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
                        performerId: this.selectedDoctorCreateValue,
                        startTime: this.selectTime,
                        beautyPackageComboId: this.selectedComboServiceValue,
                    }
                ]
            }

            // let checkDate = new Date(new Date(this.selectDate).setHours(parseInt(this.selectTime.substr(0, 2)), parseInt(this.selectTime.substr(3, 2)), 0));
            // if (checkDate < new Date()) {
            //     return this.$vs.notify({
            //         text: 'Thời gian đặt lịch không hợp lệ!',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     });
            // }

            this.$vs.loading();
            this.$crm.post('/beauty-booking/create', payload).then(() => {
                this.$vs.notify({
                    text: `Tạo mới lịch hẹn thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.popupBooking = false;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getBeautyService(dataService, organizationBranchId) {
            return new Promise((resolve, reject) => {
                this.beautyServiceData = [];
                let payload = {
                    organizationBranchId: !this.isUpdateBooking ? this.selectedBranchCreateValue : organizationBranchId,
                    keySearch: dataService ? dataService.beautyService.name : null,
                }
                this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                    res.data.content.map(x => {
                        let data = this.beautyServiceData.find(t => t.value == x.id);
                        if (!data) {
                            let result = {
                                value: x.id,
                                label: x.code + '-' + x.name,
                            }
                            this.beautyServiceData.push(result);
                        }
                    })
                    this.beautyServiceData = Array.from(new Set(this.beautyServiceData));
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyServicePack() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    organizationBranchId: this.selectedBranchCreateValue,
                    beautyServiceId: this.selectBeautyServiceValue,
                    active: this.isUpdateBooking ? -1 : null,
                };
                this.$crm.post('beauty-service-package-department/find-by-condition', payload).then(res => {
                    this.beautyServicePackageOptions = res.data.content.map(el => {
                        return {
                            value: el.beautyServicePackage.id,
                            label: el.beautyServicePackage.code + '-' + el.beautyServicePackage.name,
                            departmentId: el.beautyServicePackage.departmentId,
                        }
                    })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getDoctor() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                this.doctorCreateOptions = [];
                if (this.selectedBranchCreateValue) {
                    url += '?organizationBranchId=' + this.selectedBranchCreateValue
                }
                if (this.selectedDepartmentCreateValue) {
                    url += '&departmentId=' + this.selectedDepartmentCreateValue
                }

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorCreateOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyComboService() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/beauty-package-combo/find-by-condition', { organizationBranchId: this.selectedBranchCreateValue }).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.beautyComboService = res.data.content.map(x => {
                            return {
                                label: x.code + '-' + x.name,
                                value: x.id
                            };
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        findCustomerData() {
            const payload = {
                phoneNumber: this.phoneNumber,
                fullName: this.fullName,
                groupChatId: JSON.parse(this.groupChatId),
                type: 3,
                pageNumber: this.pageNumberManage,
                pageSize: this.pageSizeManage,
                createDateFrom: this.dateRange.startDate,
                createDateTo: this.dateRange.endDate,
                modifiedDate: this.dateRangeGrade.startDate,
                toModifiedDate: this.dateRangeGrade.endDate,
                departmentId: JSON.parse(this.selectedDepartmentValue),
                employeeName: this.employeeName,
                seen: this.selectedSeen,
                interactMethod: this.selectedInteracMethod,
                isSeeder: this.selectedSeeder,
                sourceType: this.selectedSource
            };

            this.$vs.loading();
            this.$crm.post(`/loyalty/potential-customer/find-by-condition`, payload).then(response => {
                this.$vs.loading.close();
                if (response.data.content && response.data.content.length > 0) {
                    this.customerData = response.data.content.map(t => {
                        t.stt = this.pageSizeManage * this.pageNumberManage + response.data.content.indexOf(t) + 1;
                        t.createdDateCvt = t.createdDate ? moment(t.createdDate).format("DD/MM/YYYY HH:mm:ss") : null;
                        t.phoneNumberCvt = t.phoneNumber ? this.convertPhone(t.phoneNumber) : null;
                        let group = this.dataGroupFB.find(x => x.id === t.groupChatId)
                        if (group) t.groupName = group.name
                        t.upgradedDateCvt = t.upgradedDate ? moment(t.upgradedDate).format("DD/MM/YYYY HH:mm:ss") : null;
                        t.lastMessageDateCvt = t.lastMessageDate ? moment(t.lastMessageDate).format("DD/MM/YYYY HH:mm:ss") : null;
                        t.insertedAtCvt = t.insertedAt ? moment(t.insertedAt).format("DD/MM/YYYY HH:mm:ss") : null;
                        if (this.dataConfig.length > 0) {
                            this.dataConfig.map(x => {
                                if (x.value === t.departmentId) {
                                    t.departmentName = x.label
                                }
                            })
                        }
                        return t;
                    })
                } else {
                    this.customerData = [];
                }

                this.totalPagesManage = response.data.totalPages;
                this.totalElementsManage = response.data.totalElements;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getDataZaloHub(data) {
            this.$vs.loading();
            this.$crm.post('/zalo-hub/conversation/find-by-condition', { phoneNumber: data.phoneNumber }).then(res => {
                this.$vs.loading.close();
                this.zaloHubData = res.data.content;
                this.popupShowZaloHub = true;
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        loadPageManage: function (currentPage) {
            if (this.pageNumberManage !== parseInt(currentPage) - 1) {
                this.pageNumberManage = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllRadio();
                this.findCustomerData();
            }
        },

        changePageSizeManage(number) {
            this.pageSizeManage = number;
            this.pageNumberManage = 0;
            this.currentPageManage = 1;
            this.findCustomerData();
        },

        async filterManage() {
            this.currentPageManage = 1;
            this.pageNumberManage = 0;
            await this.getAllRadio();
            this.findCustomerData();

        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },

        async getGroupByDepartment(evt) {
            await this.filterManage()
            if (JSON.parse(evt)) {
                this.$vs.loading();

                this.$crm.get(`/setting/organization-pancake-config/find-group-by-departent-id?departmentId=${evt}`).then(res => {
                    if (res.data.groupPages && res.data.groupPages.length > 0) {
                        this.groupFB = res.data.groupPages.map(el => {
                            return {
                                label: el.name,
                                value: el.id,
                                stt: res.data.groupPages.indexOf(el) + 1
                            }
                        })
                    } else {
                        this.groupFB = []
                    }
                    this.groupFB.unshift({ label: 'Tất cả', value: 'null', stt: 0 })
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } else {
                this.groupFB = this.dataGroupFB.map(el => {
                    return {
                        label: el.name,
                        value: el.id,
                        stt: this.dataGroupFB.indexOf(el) + 1
                    }
                })
                this.groupFB.unshift({ label: 'Tất cả', value: 'null', stt: 0 })
            }
        },

        dateRangePicker: function () {
            this.dateRange.startDate = new Date(new Date(this.dateRange.startDate).setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(new Date(this.dateRange.endDate).setHours(23, 59, 59, 999));
        },

        dateRangePickerUpgrade: function () {
            this.dateRangeGrade.startDate = new Date(new Date(this.dateRange.startDate).setHours(0, 0, 0, 0));
            this.dateRangeGrade.endDate = new Date(new Date(this.dateRange.endDate).setHours(23, 59, 59, 999));
        },

        getAllDepartment() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', {}).then(res => {
                    let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                    this.departmentOptions = res.data.map(el => {
                        return {
                            value: el.id,
                            label: el.departmentName,
                            organizationBranchName: branchList.find(x => x.id === el.organizationBranchId).organizationBranchName
                        }
                    });
                    resolve(res);
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },


        getDepartmentConfig() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.get('/setting/organization-pancake-config/find-config-by-organization-id').then(res => {
                    this.$vs.loading.close();
                    this.dataConfig = res.data.map(el => {
                        return {
                            value: el.departmentId,
                            label: this.departmentOptions.find(x => x.value === el.departmentId).label,
                            organizationBranchName: this.departmentOptions.find(x => x.value === el.departmentId).organizationBranchName,
                        }
                    });
                    const index = this.dataConfig.findIndex(i => i.value === 433);
                    if (index !== -1) {
                        const item = this.dataConfig[index];
                        this.dataConfig.splice(index, 1);
                        this.dataConfig.splice(2, 0, item);
                    }
                    this.dataConfig.unshift({ label: 'Tất cả', value: 'null' })
                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        showMessage(data) {
            this.$vs.loading();
            this.$crm.post('/pancake-message/find-by-condition', { conversationId: data.conversationId }).then(res => {
                this.$vs.loading.close();
                this.messageData = res.data.content.filter(el => el.originalMessage !== '').map(el => {
                    el.sendAt = moment(el.insertedAt).format('DD/MM/YYYY HH:mm');
                    return el;
                })
                this.popupHistoryMessage = true;
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getGroupFB() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get('/setting/organization-pancake-config/find-group-by-organization-id').then(res => {
                    this.$vs.loading.close();
                    if (res.data.groupPages && res.data.groupPages.length > 0) {
                        this.dataGroupFB = res.data.groupPages;
                        this.groupFB = this.dataGroupFB.map(el => {
                            return {
                                label: el.name,
                                value: el.id,
                                stt: this.dataGroupFB.indexOf(el) + 1
                            }
                        })
                    } else {
                        this.dataGroupFB = [];
                    }
                    this.groupFB.unshift({ label: 'Tất cả', value: 'null', stt: 0 })
                    resolve(res);
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        callCustomer(data) {
            this.$eventBus.$emit("beauty-call", data);
        },
    },
    mounted() {
        this.$eventBus.$on("popup-add-customer", (event) => {
            if (event) this.popupAddCustomer = false;
        })
    }
}
</script>

<style lang="scss">
.required:after {
    content: " *";
    color: red;
}

.popupError .vs-popup--header {
    background: rgba(var(--vs-danger), 1) !important;
}

#customer-manage {
    .vs-con-table {
        overflow-y: scroll;
        //height: 600px !important;

        .vs-table--content {
            overflow: visible !important;

            .vs-con-tbody {
                overflow: visible !important;
                // width: 2500px !important;
                //overflow-x: scroll !important;
            }

            .vs-table--thead th {
                position: sticky;
                top: 0;
                background: #FFFFFF;
                z-index: 999;
            }

            tr:nth-child(even) {
                background-color: #f8f8f8;
            }
        }
    }

    .vs-table--thead tr th:last-child .vs-table-text {
        width: 100px;
    }

    .ag-grid-cell-chip-customer {
        &.vs-chip-primary {
            background: rgba(var(--vs-primary), .2);
            color: rgba(var(--vs-primary), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-success {
            background: rgba(var(--vs-success), .2);
            color: rgba(var(--vs-success), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-warning {
            background: rgba(var(--vs-warning), .2);
            color: rgba(var(--vs-warning), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-danger {
            background: rgba(var(--vs-danger), .2);
            color: rgba(var(--vs-danger), 1) !important;
            font-weight: 500;
        }
    }
}

.consultation_call {
    .vs-popup--header {
        //display: none;
    }

    .vs-popup--content {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
    }

    .view_details_call {
        .vx-row {
            margin: 0 !important;
        }
    }
}

#customer_note {
    .vs-con-textarea {
        height: 300px;

        textarea {
            height: 300px;
        }
    }
}

#customer_info_popup {

    .vs-popup {
        width: 80%;
    }

    .vs-textarea {
        height: 200px;
    }

    .vs-popup--content {
        min-height: 500px;

        .con-slot-tabs {
            min-height: 500px;
        }
    }

    .scroll-area--nofications-dropdown,
    .scroll-area--cart-items-dropdowm {
        max-height: 40rem;
    }

    .flip-card {
        background-color: transparent;
        width: 300px;
        height: 150px;
        perspective: 1000px;
        font-family: sans-serif;
    }

    .title {
        font-size: 1.5em;
        font-weight: 900;
        text-align: center;
        margin: 0;
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.8s;
        transform-style: preserve-3d;
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateY(180deg);
    }

    .flip-card-front,
    .flip-card-back {
        box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.2);
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        border-radius: 1rem;
    }

    .flip-card-back {
        transform: rotateY(180deg);
    }
}

#popup-history-call {
    .vs-popup--header {
        display: none;
    }
}

#popup-history-call-record {
    .vs-popup--header {
        display: none;
    }
}

.nostar_desc {
    display: none !important;
}

#call_history {
    min-height: 400px;
}

#popup_beauty_booking {
    z-index: 54000 !important;
}

.over-text {
    max-width: 250px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.group-fb {
    .vs__dropdown-toggle {
        .vs__selected-options {
            width: 86%;

            .vs__selected {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 87%;
            }
        }
    }
}
</style>
